import LegalLayout from "./LegalLayout";
import { BRAND } from "@/components/Brand";

export default function Privacidad() {
  return (
    <LegalLayout title="Política de Privacidad">
      <p>Esta Política de Privacidad describe cómo {BRAND.legal.holder} ({BRAND.name}, en adelante el "Responsable") trata los datos personales que los usuarios facilitan al utilizar la web <a href={`https://${BRAND.domain}`}>{BRAND.domain}</a> y la aplicación asociada.</p>

      <h2>1. Responsable del tratamiento</h2>
      <ul>
        <li><strong>Titular</strong>: {BRAND.legal.holder}</li>
        <li><strong>NIF</strong>: {BRAND.legal.nif}</li>
        <li><strong>Domicilio</strong>: {BRAND.legal.fullAddress}</li>
        <li><strong>Contacto para asuntos de protección de datos</strong>: <a href={`mailto:${BRAND.contactEmail}`}>{BRAND.contactEmail}</a></li>
      </ul>

      <h2>2. Datos personales que tratamos</h2>
      <p>Recogemos y tratamos las siguientes categorías de datos:</p>
      <ul>
        <li><strong>Datos de identificación y contacto del usuario</strong>: nombre del taller, nombre de la persona responsable (opcional), correo electrónico, contraseña cifrada.</li>
        <li><strong>Datos de autenticación con Google</strong>: si accedes con Google, recibimos tu correo electrónico, nombre público y un identificador único.</li>
        <li><strong>Datos de operativa del taller introducidos por el usuario</strong>: nombres de mecánicos, horarios, vacaciones, festivos, matrículas, marcas y modelos de vehículos, teléfonos de contacto, descripciones de reparaciones. Estos datos pueden incluir, indirectamente, datos personales de terceros (clientes finales del taller); en tal caso, el usuario del servicio actúa como responsable del tratamiento respecto a sus propios clientes, y {BRAND.name} actúa como encargado del tratamiento.</li>
        <li><strong>Datos de facturación y pago</strong>: procesados directamente por Stripe. No almacenamos números completos de tarjeta.</li>
        <li><strong>Datos técnicos</strong>: dirección IP, tipo de navegador y sistema operativo, en registros de servidor por motivos de seguridad.</li>
        <li><strong>Datos analíticos</strong>: solo si el usuario acepta las cookies de análisis (ver Política de Cookies).</li>
      </ul>

      <h2>3. Finalidades y base jurídica</h2>
      <ul>
        <li><strong>Prestación del servicio</strong> (creación de cuenta, gestión de la agenda, facturación) — base: ejecución del contrato (art. 6.1.b RGPD).</li>
        <li><strong>Comunicaciones transaccionales</strong> (bienvenida, aviso de fin de prueba, recibo de pago) — base: ejecución del contrato.</li>
        <li><strong>Cumplimiento de obligaciones legales</strong> (fiscales, contables) — base: art. 6.1.c RGPD.</li>
        <li><strong>Prevención de fraude y seguridad</strong> — base: interés legítimo (art. 6.1.f RGPD).</li>
        <li><strong>Análisis estadístico</strong> mediante PostHog — base: consentimiento (art. 6.1.a RGPD). Puede revocarse en cualquier momento desde el banner de cookies.</li>
      </ul>

      <h2>4. Destinatarios y encargados del tratamiento</h2>
      <p>Los datos podrán ser comunicados a los siguientes prestadores, todos ellos sujetos a acuerdos de encargo de tratamiento conforme al artículo 28 RGPD:</p>
      <ul>
        <li><strong>Emergent</strong> (infraestructura y hosting de la aplicación) — EE.UU., con garantías apropiadas.</li>
        <li><strong>Stripe Payments Europe, Ltd.</strong> (procesamiento de pagos) — Irlanda, RGPD-compliant.</li>
        <li><strong>Resend</strong> (envío de correos transaccionales) — EE.UU., con Standard Contractual Clauses.</li>
        <li><strong>Google Ireland Ltd.</strong> (autenticación con cuenta de Google, si el usuario elige esa opción) — Irlanda.</li>
        <li><strong>PostHog</strong> (analítica web, opt-in) — EE.UU., con Standard Contractual Clauses.</li>
      </ul>
      <p>No cedemos ni vendemos datos personales a terceros con finalidades comerciales.</p>

      <h2>5. Transferencias internacionales</h2>
      <p>Algunos proveedores están ubicados fuera del Espacio Económico Europeo. En todos los casos aplicamos garantías apropiadas (Cláusulas Contractuales Tipo aprobadas por la Comisión Europea) para que la transferencia cumpla el RGPD.</p>

      <h2>6. Plazo de conservación</h2>
      <ul>
        <li>Datos de la cuenta y operativa: mientras la cuenta esté activa. Si el usuario cancela, se conservan 6 años por obligaciones contables y fiscales (art. 30 Código de Comercio).</li>
        <li>Registros de acceso: 12 meses por seguridad.</li>
        <li>Datos de facturación: 6 años.</li>
      </ul>

      <h2>7. Derechos del usuario</h2>
      <p>Como titular de tus datos personales, puedes ejercer los siguientes derechos:</p>
      <ul>
        <li>Acceso, rectificación, supresión ("derecho al olvido").</li>
        <li>Oposición y limitación del tratamiento.</li>
        <li>Portabilidad de los datos.</li>
        <li>Revocación del consentimiento en cualquier momento.</li>
        <li>Presentar una reclamación ante la Agencia Española de Protección de Datos (<a href="https://www.aepd.es">www.aepd.es</a>).</li>
      </ul>
      <p>Para ejercer estos derechos, envía un correo a <a href={`mailto:${BRAND.contactEmail}`}>{BRAND.contactEmail}</a> indicando el derecho que deseas ejercer y adjuntando copia de tu documento de identidad. Responderemos en el plazo máximo de 30 días.</p>

      <h2>8. Seguridad</h2>
      <p>Aplicamos medidas técnicas y organizativas apropiadas: cifrado en tránsito (HTTPS/TLS), contraseñas almacenadas con bcrypt, cookies de sesión HttpOnly con SameSite estricto, copias de seguridad periódicas y accesos restringidos por rol.</p>

      <h2>9. Cambios en esta política</h2>
      <p>Podemos actualizar esta política. Publicaremos siempre la fecha de la última actualización al inicio del documento, y si los cambios son sustanciales te avisaremos por correo.</p>
    </LegalLayout>
  );
}
